// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"934b43ba","900":"2d630d34","972":"29cd0e89"}[chunkId] + ".chunk.js";
};